import { CHANNELS } from "../shared/channels";
import { PollState } from "../shared/daily_poll";
import { call, listen } from "./bridge";
import { byId, flashToast } from "./dom";
import { t } from "./i18n";
import { localDay } from "./awards_store";
import { onViewShown } from "./navigation";
import { buzz } from "./tweens";

// the question of the day on home: two answers, one vote each, totals once you have answered.
// the question comes from a fixed pool (shared/daily_poll.ts), so there is no daily prompt to anyone

let state: PollState | null = null;
let busy = false;

function percent(count: number, total: number): number {
  return total ? Math.round((count / total) * 100) : 0;
}

function paint(): void {
  if (!state) return;
  const poll = state;
  byId("poll-question").textContent = t(poll.question);
  const total = poll.counts ? poll.counts[0] + poll.counts[1] : 0;
  byId("poll-options").replaceChildren(...poll.options.map((label, index) => {
    const option = document.createElement("button");
    option.type = "button";
    option.className = `poll-opt${poll.mine === index ? " mine" : ""}`;
    option.setAttribute("aria-pressed", String(poll.mine === index));
    const text = document.createElement("span");
    text.textContent = t(label);
    option.append(text);
    if (poll.counts) {
      const share = percent(poll.counts[index], total);
      const fill = document.createElement("i");
      fill.className = "poll-fill";
      fill.style.width = `${share}%`;
      const figure = document.createElement("b");
      figure.textContent = `${share}% · ${poll.counts[index]}`;
      option.prepend(fill);
      option.append(figure);
    }
    option.addEventListener("click", () => void vote(index));
    return option;
  }));
  byId("poll-hint").textContent = poll.counts
    ? t("{total} votes, tap your answer again to undo", { total })
    : t("vote to see what everyone said");
  const last = byId("poll-last");
  last.hidden = !poll.last;
  if (poll.last) {
    const [first, second] = poll.last.options;
    last.textContent = t("yesterday: {first} {a}, {second} {b}", { first: t(first), a: poll.last.counts[0], second: t(second), b: poll.last.counts[1] });
  }
}

async function vote(choice: number): Promise<void> {
  if (busy) return;
  busy = true;
  try {
    state = await call<PollState>(CHANNELS.pollVote, localDay(), choice);
    buzz(8);
    paint();
  } catch (error) {
    flashToast(String(error instanceof Error ? error.message : error).replace(/^.*Error: /, ""));
  } finally {
    busy = false;
  }
}

async function load(): Promise<void> {
  try {
    state = await call<PollState>(CHANNELS.pollGet, localDay());
    paint();
  } catch {
    // keep what is showing
  }
}

export function setupPollModule(): void {
  listen(CHANNELS.pollUpdated, () => void load());
  onViewShown("today", () => void load());
  void load();
}
